import { Link } from "react-router-dom";
import Navbar from "@/components/navbar";

export default function NotFoundPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-[80vh] flex items-center justify-center px-4">
        <div className="text-center max-w-md animate-[fade-in_0.4s_ease-out]">
          <p className="text-[7rem] sm:text-[9rem] font-heading font-bold leading-none text-white/10 select-none">
            404
          </p>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white -mt-4">
            Page not found
          </h1>
          <p className="text-secondary mt-3 text-sm sm:text-base leading-relaxed">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <Link
              to="/"
              className="bg-lime text-black rounded-full px-6 py-2.5 text-sm font-semibold hover:opacity-90 transition-opacity"
            >
              Go Home
            </Link>
            <button
              type="button"
              onClick={() => window.history.back()}
              className="text-secondary hover:text-white text-sm transition-colors cursor-pointer"
            >
              ← Go back
            </button>
          </div>
        </div>
      </main>
    </>
  );
}
